import React, { useEffect, useState } from 'react';
import { authService } from '../../services/apiService';

export default function VerifyEmailPage() {
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');

    if (!token || !email) {
      setStatus('error');
      setMessage('Invalid verification link. Please request a new one.');
      return;
    }

    authService
      .verifyEmail({ email, token })
      .then((response) => {
        if (response.access_token) {
          localStorage.setItem('authToken', response.access_token);
        }
        setStatus('success');
        setTimeout(() => {
          window.location.replace('/');
        }, 2500);
      })
      .catch((err) => {
        const msg = err.response?.data?.message || 'Verification failed. The link may be invalid or expired.';
        setStatus('error');
        setMessage(msg);
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50" style={{ fontFamily: 'sans-serif' }}>
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full text-center space-y-4">
        <img
          src="/apiboo-ghost-mascot.png"
          alt="Apiboo"
          style={{ height: 48, margin: '0 auto' }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        {status === 'verifying' && (
          <>
            <div
              style={{
                width: 40, height: 40, border: '3px solid #e5e7eb',
                borderTopColor: 'var(--accent, #8869eb)', borderRadius: '50%',
                animation: 'spin 0.8s linear infinite', margin: '0 auto',
              }}
            />
            <p style={{ color: '#6b7280', fontSize: 15 }}>Verifying your email…</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827' }}>Email verified!</h2>
            <p style={{ color: '#6b7280', fontSize: 15 }}>
              Your account is now active. Redirecting you to Apiboo…
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48 }}>❌</div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#111827' }}>Verification failed</h2>
            <p style={{ color: '#6b7280', fontSize: 15 }}>{message}</p>
            <a
              href="/"
              className="bg-blue-600"
              style={{
                display: 'inline-block', marginTop: 8, padding: '10px 24px',
                color: '#fff', borderRadius: 8,
                textDecoration: 'none', fontSize: 14, fontWeight: 500,
              }}
            >
              Open Apiboo
            </a>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
